export default {
  referral:{
    link:{
      title:'推荐计划',
      code: {
        tabName: '链接码',
        policyTitle: '推荐亿速云，每个付费新注册返回您 $10 奖励!',
        policy1: '被推荐用户必须活跃30天以上并至少花费 $10 才会被认定为有效。',
        policy2: '提取在每月1号之后的工作日结算完成并发放。',
        policy3: '您下方的推荐链接唯一标识您的账户。使用该代码链接至亿速云，从今天起开始赚钱吧！',
        linkBtn: '获取您的链接',
        shareYourLink: '分享您的链接',
        linkDesc: '此链接的使用收亿速云推荐计划相关条款的约束。条款可能随时修订。',
        Terms: '点击查看相关条款',
        getLink: '获取您的推荐链接',
      },
      payouts: {
        tabName: '提取',
        unpaidEarnings: '待付收入',
        earnings: '收入 (30天之前): ',
        earningsNotice1: '奖励将在订单支付后30天后一个月的首个工作日计入待付收入。',
        earningsNotice2: '一旦达到最低提取条件，待付收入将在每月1日后的工作日提取到账。',
        payoutSettings: '提取设置',
        payoutType: '提取类型',
        accountCredit: '账户额度（无最低提取条件）',
        paypal: 'PayPal',
        minimumPayout: '最低提现额: ',
        yourPayPalEmail: '您的PayPal账号',
        updatePayoutSettings: '更新提取设置',
        payoutHistory: '提取历史',
        historyType1: '账号余额',
        historyType2: 'PayPal',
        method: '提取类型',
        date: '日期',
        amount: '金额',
        status: '状态',
        issuedSuccessfully: '成功到账',
        issuedError: '提取失败'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/referral.js